import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { LessonModel, StudentStatsModel } from '@generativ/much-smarter-models';

import { LessonService } from '../../shared/lesson.service';
import { ExerciseService } from '../../shared/exercise.service';
import { ParamsService } from '../../../../../shared/params.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { SpinnerComponent } from '../../../../../shared/spinner/spinner.component';
import { AsyncPipe } from '@angular/common';
import { TimePipe } from '../../../../../shared/pipes/time.pipe';

@Component({
    selector: 'app-lesson-conclude',
    templateUrl: './lesson-conclude.component.html',
    styleUrls: ['./lesson-conclude.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbTooltip, RouterLink, SpinnerComponent, AsyncPipe, TimePipe]
})
export class LessonConcludeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  lesson: Observable<LessonModel>;
  lessonPerformance: Observable<StudentStatsModel>;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private lessonService: LessonService,
              private paramsService: ParamsService,
              private exerciseService: ExerciseService) {
  }

  ngOnInit() {
    const isPersistence = !!this.paramsService.getRouteDataById('persistence',
      this.activatedRoute.snapshot);

    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['lessonId']) {
        this.lessonPerformance =  isPersistence ? this.exerciseService.getPersistenceScore() :
                                  this.exerciseService.getLessonScore();
        this.lesson = this.lessonService.getLesson(params['lessonId']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
